export default __webpack_public_path__ + "static/media/check@2x-1.a2350ba0.png";